import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "antd/dist/antd.css";
import reportWebVitals from "./reportWebVitals";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import rootReducer from "./components/reducers";
import thunk from "redux-thunk";
import LanguageContextProvider from "./components/contexts/LanguageContext";

// const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store = createStore(
  rootReducer,
  {},
  // (applyMiddleware(thunk))
  composeEnhancer(applyMiddleware(thunk))
);
ReactDOM.render(
  <React.StrictMode>
    <LanguageContextProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </LanguageContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
